import { ChevronDown } from 'lucide-react';
import { memo } from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from '@/components/animate-ui/primitives/radix/accordion.tsx';

import type { AccordionWrapperProps } from './types';

export const AccordionWrapper = memo(({ label, children }: AccordionWrapperProps) => {
  return (
    <Accordion type="multiple" defaultValue={['item']} className="w-full !bg-transparent">
      <AccordionItem
        value="item"
        className="!bg-card !rounded-lg !py-2 !px-3 !border-none !shadow-sm"
      >
        <AccordionHeader>
          <AccordionTrigger className="group flex items-center justify-between w-full font-bold text-lg text-left !bg-transparent pl-4 text-foreground">
            <span>{label}</span>
            <ChevronDown className="h-4 w-4 transition-transform duration-300 ease-in-out group-data-[state=open]:rotate-180" />
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent className="mt-4 !bg-transparent text-foreground">
          {children}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
});
